export default "/images/822e653470cbb28c84f5799b2be3eeb9.avif";